/**
 * 시안(handoff/02·03_handoff)의 선 아이콘. 선 두께 1.6, 둥근 끝 (README 4.3·9장).
 * lucide 에 같은 모양이 없는 것만 여기 둡니다.
 */
function LineIcon({ size = 24, children, className = '' }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            className={className}
        >
            {children}
        </svg>
    );
}

/** 별채대화 탭: 말풍선 둘 */
export function RoomIcon(props) {
    return (
        <LineIcon {...props}>
            <path d="M3.5 6.5A2.5 2.5 0 0 1 6 4h7a2.5 2.5 0 0 1 2.5 2.5v4A2.5 2.5 0 0 1 13 13H8.5L5.5 15.5V13A2 2 0 0 1 3.5 11z" />
            <path d="M15.5 8.5H18a2.5 2.5 0 0 1 2.5 2.5v4A2 2 0 0 1 18.5 17v2.5l-3-2.5H11a2.5 2.5 0 0 1-2.5-2.5V15" />
        </LineIcon>
    );
}

/** 멤버 탭: 두 사람 */
export function MembersIcon(props) {
    return (
        <LineIcon {...props}>
            <circle cx="9" cy="8" r="3" />
            <path d="M3.5 19a5.5 5.5 0 0 1 11 0" />
            <circle cx="17" cy="9" r="2.5" />
            <path d="M16 14.2a4.5 4.5 0 0 1 5 4.8" />
        </LineIcon>
    );
}

/** 나 탭 */
export function MeIcon(props) {
    return (
        <LineIcon {...props}>
            <circle cx="12" cy="8" r="3.5" />
            <path d="M5 20a7 7 0 0 1 14 0" />
        </LineIcon>
    );
}

/** 상회칠판 탭: 칠판 */
export function BoardIcon(props) {
    // 상회칠판: 칠판 틀(17×12.5, 반경 1.5) + 글씨 줄 + 다리 둘 (시안 09 · 08 결정 31)
    return (
        <LineIcon {...props}>
            <rect x="3.5" y="4" width="17" height="12.5" rx="1.5" />
            <path d="M7.5 8.5h5" />
            <path d="M7.5 11.5h3" />
            <path d="M15 12.5h2" />
            <path d="M8 20l1.5-3.5" />
            <path d="M16 20l-1.5-3.5" />
        </LineIcon>
    );
}

/** 고민(고민으로 올리기, '+' 메뉴): 접힌 편지 */
export function WorryIcon(props) {
    return (
        <LineIcon {...props}>
            <path d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v8a2.5 2.5 0 0 1-2.5 2.5H10l-4 3v-3h0.5A2.5 2.5 0 0 1 4 14.5z" />
            <path d="M12 8v3.5" />
            <path d="M12 14h.01" />
        </LineIcon>
    );
}

/** 사진 보내기(준비 중) */
export function PhotoIcon(props) {
    return (
        <LineIcon {...props}>
            <rect x="3.5" y="5" width="17" height="14" rx="2.5" />
            <circle cx="9" cy="10" r="1.6" />
            <path d="M20.5 16l-5-5-8 8" />
        </LineIcon>
    );
}
